/**
 * A page is a document whose `meta.experience` names the page that owns it (the key keeps its
 * original name so documents made by the first worlds still open). The document stays an
 * ordinary event-sourced Huebo document; only the screen around the canvas changes.
 */
export type PageMeta = {
  id: string
  /** Page format version, bumped when a page's generator or rules change incompatibly. */
  version: number
}

export function pageMetaOf(meta: { experience?: unknown } | null | undefined): PageMeta | null {
  const raw = meta?.experience as Partial<PageMeta> | undefined
  if (!raw || typeof raw.id !== 'string' || raw.id.length === 0) return null
  return { id: raw.id, version: typeof raw.version === 'number' ? raw.version : 1 }
}

/**
 * Durable page events are named `experience.<page>.<verb>` and are undo boundaries
 * (src/events/appLog.ts `isUndoBoundaryEvent`).
 */
export const PAGE_EVENT_PREFIX = 'experience.'
